function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndiaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flag",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1990 1050",
    style: {
      enableBackground: "new 0 0 1990 1050"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF9933"
    },
    width: 1990,
    height: 343.421
  }), /*#__PURE__*/React.createElement("rect", {
    y: 343.421,
    style: {
      fill: "#FFFFFF"
    },
    width: 1990,
    height: 363.157
  }), /*#__PURE__*/React.createElement("rect", {
    y: 706.579,
    style: {
      fill: "#128807"
    },
    width: 1990,
    height: 343.421
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000088"
    },
    d: "M995.002,384.21c-77.204,0-139.79,63.035-139.79,140.79c0,77.755,62.586,140.79,139.79,140.79 c77.2,0,139.786-63.035,139.786-140.79C1134.788,447.245,1072.202,384.21,995.002,384.21z M1074.772,618.994 c-0.786-2.496-3.078-4.319-5.817-4.319c-3.385,0-6.128,2.765-6.128,6.176c0,2.213,1.164,4.141,2.901,5.229 c-5.688,4.044-11.713,7.628-18.057,10.667c-0.358-3.068-2.916-5.459-6.061-5.459c-3.384,0-6.131,2.765-6.131,6.173 c0,1.463,0.526,2.787,1.372,3.846c-6.344,2.316-12.939,4.091-19.72,5.335c0.075-0.388,0.122-0.79,0.122-1.201 c0-3.41-2.748-6.174-6.132-6.174c-3.388,0-6.131,2.763-6.131,6.174c0,0.993,0.256,1.918,0.668,2.751 c-3.518,0.305-7.063,0.493-10.656,0.493c-3.309,0-6.579-0.17-9.826-0.43c0.511-0.899,0.826-1.926,0.826-3.032 c0-3.41-2.747-6.176-6.131-6.176c-3.388,0-6.132,2.766-6.132,6.176c0,0.564,0.099,1.101,0.244,1.619 c-7.205-1.251-14.205-3.108-20.919-5.564c1.478-1.128,2.445-2.898,2.445-4.909c0-3.41-2.743-6.174-6.132-6.174 c-3.384,0-6.131,2.763-6.131,6.174c0,0.285,0.047,0.558,0.086,0.835c-6.305-2.951-12.323-6.417-17.994-10.36 c2.343-0.869,4.021-3.116,4.021-5.776c0-3.408-2.747-6.174-6.132-6.174c-3.239,0-5.864,2.54-6.088,5.746 c-5.853-4.838-11.241-10.221-16.115-16.056c3.211-0.194,5.766-2.852,5.766-6.138c0-3.41-2.748-6.173-6.132-6.173 c-2.72,0-5,1.797-5.801,4.267c-4.131-5.855-7.783-12.074-10.868-18.624c0.134,0.008,0.26,0.039,0.393,0.039 c3.388,0,6.131-2.765,6.131-6.175s-2.743-6.174-6.131-6.174c-1.863,0-3.51,0.853-4.634,2.174 c-2.516-6.872-4.414-14.044-5.688-21.429c0.708,0.289,1.478,0.457,2.292,0.457c3.388,0,6.132-2.765,6.132-6.175 s-2.744-6.174-6.132-6.174c-1.38,0-2.641,0.477-3.667,1.253c-0.299-3.533-0.487-7.1-0.487-10.712 c0-3.521,0.157-7.003,0.444-10.449c0.994,0.697,2.193,1.11,3.494,1.11c3.385,0,6.132-2.763,6.132-6.173s-2.747-6.176-6.132-6.176 c-0.739,0-1.438,0.152-2.095,0.394c1.262-7.323,3.152-14.431,5.641-21.253c1.12,1.443,2.846,2.389,4.811,2.389 c3.384,0,6.132-2.765,6.132-6.176c0-3.411-2.748-6.174-6.132-6.174c-0.24,0-0.464,0.043-0.692,0.071 c3.082-6.607,6.706-12.905,10.849-18.814c0.908,2.27,3.105,3.879,5.684,3.879c3.388,0,6.131-2.765,6.131-6.176 c0-3.153-2.358-5.726-5.389-6.098c4.477-5.35,9.394-10.307,14.696-14.824c0.558,2.829,3.034,4.963,6.01,4.963 c3.384,0,6.132-2.763,6.132-6.174c0-2.44-1.419-4.529-3.455-5.532c5.935-4.206,12.251-7.896,18.898-11.003 c-0.063,0.35-0.11,0.706-0.11,1.075c0,3.41,2.747,6.174,6.131,6.174c3.388,0,6.132-2.763,6.132-6.174 c0-2.102-1.045-3.954-2.641-5.071c6.654-2.447,13.588-4.297,20.722-5.562c-0.023,0.229-0.067,0.451-0.067,0.687 c0,3.41,2.744,6.176,6.132,6.176c3.384,0,6.128-2.765,6.128-6.176c0-0.77-0.157-1.502-0.412-2.183 c3.18-0.25,6.387-0.416,9.633-0.416c3.608,0,7.169,0.19,10.699,0.497c-0.314,0.746-0.495,1.568-0.495,2.431 c0,3.41,2.743,6.173,6.131,6.173c3.388,0,6.132-2.763,6.132-6.173c0-0.287-0.047-0.562-0.086-0.84 c6.996,1.297,13.788,3.167,20.313,5.606c-0.959,1.091-1.565,2.512-1.565,4.085c0,3.41,2.743,6.175,6.131,6.175 c3.223,0,5.841-2.518,6.085-5.704c6.194,3.016,12.082,6.568,17.648,10.546c-1.883,1.055-3.168,3.055-3.168,5.378 c0,3.408,2.743,6.174,6.128,6.174c2.838,0,5.2-1.95,5.9-4.586c5.192,4.481,10.015,9.376,14.401,14.659 c-2.429,0.823-4.19,3.108-4.19,5.827c0,3.41,2.747,6.176,6.131,6.176c2.107,0,3.962-1.071,5.063-2.696 c3.809,5.58,7.166,11.492,10.039,17.682c-0.043-0.002-0.083-0.014-0.126-0.014c-3.384,0-6.131,2.765-6.131,6.176 c0,3.41,2.747,6.175,6.131,6.175c1.737,0,3.294-0.734,4.41-1.9c2.449,6.867,4.3,14.016,5.519,21.383 c-0.719-0.299-1.505-0.467-2.334-0.467c-3.385,0-6.128,2.763-6.128,6.174s2.743,6.176,6.128,6.176c1.36,0,2.602-0.459,3.62-1.211 c0.247,3.23,0.417,6.488,0.417,9.784c0,3.579-0.185,7.112-0.483,10.613c-0.888-0.511-1.91-0.825-3.011-0.825 c-3.384,0-6.127,2.763-6.127,6.174c0,3.411,2.743,6.176,6.127,6.176c0.535,0,1.042-0.089,1.533-0.218 c-1.25,7.027-3.054,13.861-5.432,20.425c-1.117-1.2-2.693-1.958-4.453-1.958c-3.384,0-6.132,2.766-6.132,6.176 s2.747,6.173,6.132,6.173c0.047,0,0.09-0.012,0.142-0.014c-2.944,6.28-6.403,12.26-10.31,17.907 c-1.093-1.69-2.979-2.811-5.133-2.811c-3.384,0-6.128,2.763-6.128,6.174c0,2.74,1.781,5.035,4.233,5.843 C1084.485,609.926,1079.803,614.659,1074.772,618.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000088"
    },
    d: "M995.002,500.729c-13.309,0-24.102,10.867-24.102,24.271c0,13.404,10.793,24.271,24.102,24.271 c13.309,0,24.098-10.866,24.098-24.271C1019.1,511.596,1008.311,500.729,995.002,500.729z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1000.953,475.959 995.344,404.605 995.324,404.605 989.719,475.959 995.301,500.434  995.301,500.729 995.336,500.581 995.367,500.729 995.367,500.434  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "946.255,519.8 875.411,525.451 875.411,525.467 946.255,531.118 970.554,525.493  970.849,525.493 970.703,525.459 970.849,525.425 970.554,525.425  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "964.91,486.165 910.845,439.705 910.833,439.717 956.962,494.168 978.096,507.497  978.305,507.706 978.222,507.578 978.352,507.657 978.144,507.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "956.537,495.846 892.21,465.411 892.202,465.425 950.972,505.679 974.846,512.916  975.097,513.062 974.987,512.959 975.133,513.003 974.877,512.856  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "949.278,506.824 879.463,493.433 879.459,493.451 946.31,517.74 971.222,518.775  971.505,518.854 971.372,518.783 971.524,518.787 971.242,518.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "975.754,480.082 934.495,421.8 934.483,421.81 966.116,485.906 983.407,503.999  983.556,504.252 983.509,504.108 983.615,504.219 983.462,503.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "988.178,476.104 965.479,408.275 965.464,408.279 977.283,478.861 988.619,501.228  988.689,501.515 988.685,501.362 988.752,501.497 988.681,501.212  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1044.413,519.82 1115.261,525.471 1115.261,525.489 1044.413,531.138 1020.11,525.513  1019.819,525.513 1019.969,525.479 1019.819,525.445 1020.11,525.445  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1025.758,486.185 1079.823,439.725 1079.835,439.737 1033.706,494.187 1012.575,507.517  1012.367,507.726 1012.445,507.598 1012.32,507.677 1012.524,507.469  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1034.134,495.866 1098.458,465.431 1098.466,465.445 1039.7,505.699 1015.826,512.936  1015.566,513.082 1015.68,512.979 1015.535,513.023 1015.791,512.876  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1041.39,506.843 1111.204,493.453 1111.208,493.471 1044.358,517.759 1019.446,518.795  1019.163,518.874 1019.297,518.802 1019.143,518.808 1019.426,518.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1014.918,480.104 1056.173,421.82 1056.185,421.83 1024.552,485.926 1007.265,504.021  1007.112,504.274 1007.159,504.128 1007.053,504.239 1007.206,503.985  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1002.49,476.124 1025.188,408.295 1025.204,408.301 1013.389,478.881 1002.053,501.248  1001.982,501.535 1001.982,501.382 1001.916,501.519 1001.986,501.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1000.953,574.256 995.344,645.612 995.324,645.612 989.719,574.256 995.301,549.781  995.301,549.487 995.336,549.635 995.367,549.487 995.367,549.781  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "964.91,564.053 910.845,610.513 910.833,610.5 956.962,556.048 978.096,542.721  978.305,542.511 978.222,542.64 978.352,542.559 978.144,542.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "956.537,554.37 892.21,584.807 892.202,584.791 950.972,544.538 974.846,537.302  975.097,537.155 974.987,537.258 975.133,537.214 974.877,537.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "949.278,543.394 879.463,556.783 879.459,556.767 946.31,532.478 971.222,531.441  971.505,531.364 971.372,531.435 971.524,531.429 971.242,531.506  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "975.754,570.133 934.495,628.416 934.483,628.408 966.116,564.312 983.407,546.217  983.556,545.963 983.509,546.108 983.615,545.999 983.462,546.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "988.178,574.112 965.479,641.941 965.464,641.937 977.283,571.357 988.619,548.988  988.689,548.703 988.685,548.853 988.752,548.719 988.681,549.006  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1025.758,564.033 1079.823,610.493 1079.835,610.479 1033.706,556.028 1012.575,542.701  1012.367,542.492 1012.445,542.62 1012.32,542.539 1012.524,542.749  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1034.134,554.35 1098.458,584.787 1098.466,584.771 1039.7,544.518 1015.826,537.282  1015.566,537.135 1015.68,537.238 1015.535,537.195 1015.791,537.339  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1041.39,543.375 1111.204,556.763 1111.208,556.747 1044.358,532.458 1019.446,531.421  1019.163,531.344 1019.297,531.415 1019.143,531.409 1019.426,531.486  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1014.918,570.113 1056.173,628.396 1056.185,628.388 1024.552,564.292 1007.265,546.197  1007.112,545.943 1007.159,546.088 1007.053,545.979 1007.206,546.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000088"
    },
    points: "1002.49,574.092 1025.188,641.921 1025.204,641.917 1013.389,571.335 1002.053,548.968  1001.982,548.683 1001.982,548.833 1001.916,548.699 1001.986,548.986  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/india_flag.ade62ed0d973d9ff6c1ca5750fae1502.svg";
export { ForwardRef as ReactComponent };